import { useEffect, useMemo, useRef } from "react"
import { Tab, CircularProgress } from "@mui/material"
import { track } from "helpers/analytics"
import { TRACKING_EVENTS, STATUSES } from "../constants"
import { TAB_PROPS } from "../shapes"

export default function SummaryTab({ action, label, activeTab, handleChange, index, summaryState, resource }) {
  const tracked = useRef(false)
  const isSelected = activeTab === index

  useEffect(() => {
    if (isSelected && summaryState.summary && !tracked.current) {
      track(TRACKING_EVENTS.VIEWED, { summaryType: action, resource })
      tracked.current = true
    }
    if (!isSelected && tracked.current) {
      tracked.current = false
    }
  }, [isSelected, summaryState.summary, action, resource])

  const status = useMemo(() => {
    if (!summaryState) {
      return STATUSES.NOT_STARTED
    }
    if (summaryState.error) {
      return STATUSES.ERROR
    } else if (summaryState.summary) {
      return STATUSES.DONE
    }
    return STATUSES.IN_PROGRESS
  }, [summaryState])

  return <Tab
    label={label}
    value={action}
    selected={isSelected}
    icon={status === STATUSES.IN_PROGRESS && <CircularProgress size={16} color="inherit" />}
    iconPosition="start"
    classes={{
      selected: "ai-summary-tab-selected",
      root: "ai-summary-tab-root",
    }}
    onClick={() => handleChange(index, action)}
  />
}

SummaryTab.propTypes = TAB_PROPS
